import { HttpHeaders,HttpClient,HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '../../../app/shared/services/api.service';
import {environment} from '../../../environments/environment';
import { IGlobalSearchParam } from '../../shared/models/Global-Search.model';


@Injectable({
  providedIn: 'root'
})
export class VendorInvoicesService{
    constructor(
        private http: HttpClient,
        private apiService: ApiService
    ) { }
    public searchInvoiceReport(invoiceReportSearchParam:IGlobalSearchParam):Observable<any> {
      console.log(invoiceReportSearchParam);
      return this.apiService.post(`Invoices/SearchInvoiceReport`,invoiceReportSearchParam)
    }
    public exportInvoiceReport(invoiceReportSearchParam:IGlobalSearchParam):Observable<any> {
      return this.http.post(`${environment.apiRoot}Invoices/ExportInvoiceReport`,
      invoiceReportSearchParam ,
      {  
          responseType: 'blob',
          observe: 'response'
       });
    }
}